import { Box, Typography } from '@mui/material';

export function ReportsErrorBox({ error }: { error: string }) {
  return (
    <Box
      sx={({ palette }) => ({
        padding: '15px',
        borderRadius: '4px',
        backgroundColor: palette.red.light,
        border: `1px solid ${palette.grey[600]}`,
      })}
    >
      <Typography sx={{ color: ({ palette }) => palette.red.main }}>{error}</Typography>
    </Box>
  );
}
